import axios from 'axios';

import amostras from './amostras.requester';
import amostrasCatalisadores from './amostras-catalisadores.requester';
import amostrasComerciais from './amostras-comerciais.requester';
import amostrasExportacao from './amostras-exportacao.requester';
import amostrasPlacas from './amostras-placas.requester';
import amostrasUtinga from './amostras-utinga.requester';
import amostrasLogs from './amostras-logs.requester';
import auth from './auth.requester';
import bags from './bags.requester';
import balancas from './balancas.requester';
import balancasMarcasEModelos from './balancas-marcas-e-modelos.requester';
import ensaios from './ensaios.requester';
import ensaioAliquotaLogResultados from './ensaio-aliquota-log-resultados.requester';
import ensaiosMetodos from './ensaios-metodos.requester';
import ensaiosAliquotas from './ensaios-aliquotas.requester';
import fornecedoresSap from './fornecedores-sap.requester';
import pedidosSap from './pedidos-sap.requester';
import placas from './placas.requester';

// backend base URL
axios.defaults.baseURL = process.env.VUE_APP_URL_API;
// send authentication cookie
axios.defaults.withCredentials = true;

// force reload on version update
axios.interceptors.response.use((res) => {
  const version = res?.headers['katalis-version'];
  if (
    version &&
    res.config.method === 'get' &&
    version !== localStorage.getItem('katalis-version')
  ) {
    localStorage.setItem('katalis-version', version);
    window.location.reload();
  }
  return Promise.resolve(res);
});

export default {
  amostras,
  amostrasCatalisadores,
  amostrasComerciais,
  amostrasExportacao,
  amostrasPlacas,
  amostrasUtinga,
  amostrasLogs,
  auth,
  bags,
  balancas,
  balancasMarcasEModelos,
  ensaios,
  ensaioAliquotaLogResultados,
  ensaiosMetodos,
  ensaiosAliquotas,
  fornecedoresSap,
  pedidosSap,
  placas,
};
